function AMinus() {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3224 9.5835H17.6406V10.4168H21.3224V9.5835Z"
        fill="#383838"
      />
      <path
        d="M16.2089 14.9998H15.2628L11.6833 4.45296C11.6066 4.29671 11.4787 4.1665 11.2998 4.1665H10.8907C10.6861 4.1665 10.5583 4.29671 10.4816 4.45296L6.90204 14.9998H5.98158C5.85374 14.9998 5.77704 15.104 5.77704 15.2082V15.6248C5.77704 15.755 5.85374 15.8332 5.98158 15.8332H8.84522C8.94749 15.8332 9.04977 15.755 9.04977 15.6248V15.2082C9.04977 15.104 8.94749 14.9998 8.84522 14.9998H7.77136L8.89636 11.6665H13.2685L14.3935 14.9998H13.3452C13.2174 14.9998 13.1407 15.104 13.1407 15.2082V15.6248C13.1407 15.755 13.2174 15.8332 13.3452 15.8332H16.2089C16.3111 15.8332 16.4134 15.755 16.4134 15.6248V15.2082C16.4134 15.104 16.3111 14.9998 16.2089 14.9998ZM9.17761 10.8332L11.0952 5.26025L12.9873 10.8332H9.17761Z"
        fill="#383838"
      />
    </svg>
  );
}

export default AMinus;
